import { render, staticRenderFns } from "./ScienceDetail.vue?vue&type=template&id=330ac2d3&scoped=true&"
import script from "./ScienceDetail.vue?vue&type=script&lang=js&"
export * from "./ScienceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScienceDetail.vue?vue&type=style&index=0&id=330ac2d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ac2d3",
  null
  
)

export default component.exports